import { useCallback, useEffect } from 'react'

import { showLoading } from 'services/util'

import { handleEscapeKey } from 'sites/auctions/components/utils'
import NumberRow from './NumberRow'
import css from '../../components/sass/confirmmodal.module.scss'
import themeCss from '../../components/sass/theme.module.scss'

export default function ConfirmMarkDonationAsPaid({setShowConfirmModal, updateDonation, data}) {

  const loggedInUser = data.loggedInUser

  const toggleModal = useCallback(() => {
      setShowConfirmModal(false)
    }, [setShowConfirmModal])
  
  useEffect(() => {
    const onKeyDown = (event) => handleEscapeKey(event, toggleModal)
    //add event listener for when modal is mounted
    document.addEventListener('keydown', onKeyDown)
    //clean up when modal is unmounted
    return () => document.removeEventListener('keydown', onKeyDown)

  }, [toggleModal])

  const performConfirm = (test) => {

    const input = { registrationId: data.registrationId }

    if (test) {
      input['donationPayment'] = null
    } else {
      input['donationPayment'] = JSON.stringify({ message: "Marked as paid by admin: " + loggedInUser.cognitoUser.username })
    }

    showLoading(true)
    updateDonation(input)
  }

  console.log('daaaataaaaa', data)

  return (
    <div className={css['modal-container']}>
      <div className={themeCss['modal-background']} onClick={()=>toggleModal()}> </div>
      <div className={`${css['modal-content']} }`}>

        <div>
          <div className={css['withdata-text']}>
            <h3>CONFIRM MARKING DONATION AS PAID</h3>

            {data.donationsMarkedPaid && <>
              <div className={css['number-row']}><h4>DONATION</h4><p>BEING MARKED AS PAID FOR {data?.attendeeName?.toUpperCase()}</p></div>
              <NumberRow number={data.totalMarkedPaid} dollar={true} text={'TOTAL BEING MARKED AS PAID'} />
            </>}
            
          </div> 
        </div>

        {/* {data.errorMessage && <p>Error</p>} */}

        <div className={css['button-options']}>
          <button className={`${themeCss['button']} ${themeCss['FilledWhite']} ${themeCss['centered-button']}`}
            onClick={()=>toggleModal()}>Cancel</button>          
          <button className={`${themeCss['FilledBlue']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`} 
            onClick={()=> performConfirm()}>Confirm Mark As Paid</button>
          
{/*         //leave in for testing purposes
          <button 
            className={`${themeCss['FilledYellow']} ${themeCss['button']} ${themeCss['centered-button']} ${css['modal-buttontext-fixing']}`} 
            onClick={()=> performConfirm(true)}>Test-Unpaid</button> */}

        </div>
      </div>    
    </div>
  )
}